class NewsAccordion extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);

    // 開いている本文の高さ変化に追従する。開いた瞬間の scrollHeight を固定すると、
    // フォントのスワップ（font-display: swap）や画像の遅延読み込みで中身が後から
    // 高くなったとき、増えた分が overflow: hidden に隠れて見えなくなる。
    //
    // 監視対象は .news-body-inner であって .news-body ではない。.news-body を
    // 監視すると max-height の変更がサイズ変化として跳ね返り無限ループになる。
    this.observer = new ResizeObserver(() => this.syncHeight());
    this.openBody = null;
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.observer.disconnect();
    this.openBody = null;
  }

  handleClick(event) {
    const header = event.target.closest('.news-item-header');
    if (!header || !this.contains(header)) return;

    const item = header.closest('.news-item');
    const wasOpen = item.classList.contains('open');

    this.closeAll();
    if (!wasOpen) this.open(item);
  }

  open(item) {
    const header = item.querySelector('.news-item-header');
    const inner = item.querySelector('.news-body-inner');

    item.classList.add('open');
    if (header) header.setAttribute('aria-expanded', 'true');

    this.openBody = item.querySelector('.news-body');
    this.syncHeight();

    if (inner) this.observer.observe(inner);
  }

  syncHeight() {
    if (!this.openBody) return;
    this.openBody.style.maxHeight = this.openBody.scrollHeight + 'px';
  }

  closeAll() {
    // disconnect() の時点で保留中の通知も含めて以後の通知は止まる。
    // openBody を null にするのは参照を残さないためで、レース対策ではない。
    this.observer.disconnect();
    this.openBody = null;

    this.querySelectorAll('.news-item').forEach((item) => {
      item.classList.remove('open');

      const header = item.querySelector('.news-item-header');
      if (header) header.setAttribute('aria-expanded', 'false');

      const body = item.querySelector('.news-body');
      if (body) body.style.maxHeight = '';
    });
  }
}

customElements.define('news-accordion', NewsAccordion);
